import { AdminRoutes } from 'pages/admin/route/type'

const SUPER_ADMIN_ROOT = `/${AdminRoutes.root}`

export const isSuperAdminPath = (pathname: string): boolean =>
  pathname === SUPER_ADMIN_ROOT || pathname.startsWith(`${SUPER_ADMIN_ROOT}/`)
